<template>
  <!-- Change this to show only comment box when there is an actual comment or when add-comment-button is clicked -->
  <transition
    name="slide-top"
    tag="div"
    mode="out-in">
    <div class="container comment-section" v-if='this.comment.showComment || question.comment_value != "" || question.comment == 0' >
      <div  :class="{'comment-card': comment.questionIsFocussed, 'comment-card-collapsed': !comment.questionIsFocussed}" @mouseover="hoverComment()" @mouseleave="leaveComment()">
        <input v-focus="comment.commentFocussed" style="opacity: 0; height: 0;"/>
        <b-input v-model="question.comment_value" class="comment-field" type="textarea" placeholder="Opmerkingen" @focus="comment.commentFocussed=true" @blur="blurComment()"></b-input>

      </div>
        

    </div>
  </transition>

</template>

<script>
export default {
   data () {
    return {
      fc: false
    }
  },
  directives: { focus: {
    inserted: function (el) {
    el.focus()
    }
  }
  },
  inject: ['question', 'comment'],
  // created () {
  //   console.log(this.question)
  //   console.log(this.comment)
  // },
  
  methods: {
    leaveComment () {
      if (!this.comment.commentFocussed && this.question.comment_value !== '') {
        this.comment.questionIsFocussed = false
      } else if (!this.comment.commentFocussed) {
        // this.comment = false
        this.comment.questionIsFocussed = false

      }
    },
    blurComment () {
      this.comment.questionIsFocussed = false
      this.comment.commentFocussed = false
    },
    hoverComment () {
      this.comment.questionIsFocussed=true
      this.comment.showComment = true

    }
  }
}
</script>

<style scoped>

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-top-enter-active {
  transition: all .2s ease;

}
.slide-top-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-top-enter, .slide-top-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}
.slide-top-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.comment-section {
  max-width: 980px;
}

.comment-card {
  margin-top: -35px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 1px 30px rgba(0,0,0,0.06);
  padding-top: 33px;
  padding-bottom: 33px;
  /* border-right: 10px solid; */
  max-width: 400px;
  margin-left: auto;
  /* border-color: #808080; */
  /* height: 150px; */
  position: relative;
  padding: 10px;
  transition: margin-top 0.3s, margin-right 0.3s, box-shadow 0.3s;
  transition-delay: 400ms;
  transition-timing-function: ease;
}

.comment-card-collapsed {
  margin-top: -125px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 1px 10px rgba(0,0,0,0.06);
  padding-top: 33px;
  padding-bottom: 33px;
  /* border-right: 10px solid; */
  max-width: 400px;
  margin-left: auto;
  margin-right: 20px;
  /* border-color: #808080; */
  /* height: 150px; */
  position: relative;
  padding: 10px;
  transition: margin-top 0.4s, margin-right 0.4s, box-shadow 0.4s;
  transition-delay: 400ms;
  transition-timing-function: ease;
}

.comment-card-collapsed .textarea {
  color: #999999;
}

.comment-field {
  /* margin-bottom: -34px; */
}

/* .textarea:focus {
  border-color: white;
  outline: none;
} */

/* .textarea:hover {
  border-color: #f8f8f8;
} */
</style>



// WEBPACK FOOTER //
// src/components/elements/CommentBox.vue